import { render, staticRenderFns } from "./stake.vue?vue&type=template&id=62eb7c5e&scoped=true&"
import script from "./stake.vue?vue&type=script&lang=js&"
export * from "./stake.vue?vue&type=script&lang=js&"
import style0 from "./stake.vue?vue&type=style&index=0&id=62eb7c5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62eb7c5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62eb7c5e')) {
      api.createRecord('62eb7c5e', component.options)
    } else {
      api.reload('62eb7c5e', component.options)
    }
    module.hot.accept("./stake.vue?vue&type=template&id=62eb7c5e&scoped=true&", function () {
      api.rerender('62eb7c5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pages/stake.vue"
export default component.exports